import PropTypes from 'prop-types';
import React from 'react';
import ModalActionCreator from 'action_creators/modal';
import PricingStore from 'stores/plugins/pricing';
import { t } from 'services/translation';
import _ from 'underscore';

class CancellationPolicy extends React.Component {
  static displayName = 'CancellationPolicy';

  static propTypes = {
    is_mobile: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    has_cancellation: PropTypes.bool.isRequired,
    zero_priced: PropTypes.bool,
  };

  _clicked = (e) => {
    e.preventDefault();
    ModalActionCreator.show({
      content: this._modalContent(),
      triggeringElement: e.currentTarget,
      className: 'small CancellationPolicy-Modal',
    });
  };

  componentDidMount() {
    PricingStore.changed.add(this._pricingChanged);
  }

  _pricingChanged = () => {
    this.setState({
      zero_priced: PricingStore.state.get('zero_priced'),
      fully_discounted: PricingStore.state.get('fully_discounted'),
      includes_booking_fee:
        parseFloat(PricingStore.state.get('booking_fee')) > 0,
    });
  };

  _renderText = () => {
    return (
      <div>
        <p>{t(this.props.description)}</p>
      </div>
    );
  };

  _modalContent = () => {
    return (
      <div className="CancellationPolicy-Modal-content">
        <b>{t('CANCELLATION_POLICY')}</b>
        <hr />
        {this._renderText()}
      </div>
    );
  };

  _renderNoText = () => {
    return <span>{t('NO_CANCELLATIONS')}</span>;
  };

  _renderTrigger = () => {
    const translatedString = t(this.props.description);

    return (
      <a
        data-testid="cp-link"
        href="#"
        className="CancellationPolicy brand-color responsive-truncate"
        onClick={this._clicked}
      >
        {_.str.truncate(translatedString, 250)}
      </a>
    );
  };

  render() {
    return this.props.has_cancellation
      ? this._renderTrigger()
      : this._renderNoText();
  }
}

export default CancellationPolicy;
